import React, { useEffect, useState } from 'react';

const API_URL = window.location.origin;

export function TelegramAuthHandler() {
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        console.log('🔍 TelegramAuthHandler - компонент загружен');

        // Получаем параметры из URL
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id');
        const hash = urlParams.get('hash');
        const auth_date = urlParams.get('auth_date');
        const username = urlParams.get('username');
        const first_name = urlParams.get('first_name');
        const last_name = urlParams.get('last_name');

        console.log('📥 Параметры из URL:', { id, hash: hash ? 'есть' : 'нет', auth_date, username });

        if (!id || !hash) {
            console.error('❌ Нет id или hash в URL');
            setStatus('error');
            return;
        }

        // Отправляем данные на бэкенд для верификации
        fetch(`${API_URL}/api/auth/telegram-verify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id,
                hash,
                auth_date,
                username,
                first_name,
                last_name
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log('📥 Ответ от сервера:', data);

                if (data.success) {
                    console.log('✅ Авторизация успешна!');
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('user', JSON.stringify(data.user));
                    console.log('💾 Токен и пользователь сохранены');
                    setStatus('success');

                    // Перенаправляем на главную
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 1000);
                } else {
                    console.error('❌ Ошибка авторизации:', data.error);
                    setStatus('error');
                }
            })
            .catch(err => {
                console.error('❌ Ошибка запроса:', err);
                setStatus('error');
            });
    }, []);

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card" style={{ textAlign: 'center' }}>
                    {status === 'loading' && (
                        <>
                            <div className="spinner"></div>
                            <p>Авторизация через Telegram...</p>
                        </>
                    )}
                    {status === 'success' && (
                        <>
                            <div className="success-icon">✅</div>
                            <p>Авторизация успешна!</p>
                            <p>Перенаправление...</p>
                        </>
                    )}
                    {status === 'error' && (
                        <>
                            <div className="error-icon">❌</div>
                            <p>Ошибка авторизации</p>
                            <button onClick={() => window.location.href = '/'}>Вернуться на главную</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}